import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { ASSET_LEASES_API } from "../../common/Constants";
import HttpUtil from "../../common/HttpUtil";
import AlertComponent from "../../common/AlertComponent";
import { getDescription } from "../../common/Util";
import { getDisplayDate } from "../../lease/DateUtil";

// const { SearchBar } = Search; temp hided

function requestorFormattor(cell, row) {
  const requestorType = row.requestorType;
  const requestor = row.requestor;
  let name = "";

  if (requestorType === "Individual") {
    name = requestor.firstName;
  } else if (requestorType === "Organization") {
    name = requestor.name;
  } else if (requestorType === "Incubatee") {
    name = requestor.name;
  }
  return name;
}

function actionsFormater(cell, row) {
  return (
    <Link
      to={`/asset/lease/${row._id}`}
      role="button"
      className="list-action-btn-info"
    >
      View
    </Link>
  );
}

const ASSET_LEASE_COLUMNS = [
  {
    dataField: "requestor",
    text: "Requestor",
    sort: true,
    formatter: requestorFormattor
  },

  {
    dataField: "requestorType",
    text: "Requestor Type",
    sort: true
  },

  {
    dataField: "status",
    text: "Status",
    formatter: (cell, row) =>
      getDescription("AssetLease", row.stage, row.status)
  },

  {
    dataField: "createdAt",
    text: "Requested At",
    sort: true,
    formatter: cell => getDisplayDate(cell)
  },

  {
    dataField: "actions",
    text: "Actions",
    isDummyField: true,
    formatter: actionsFormater
  }
];

class AssetLeaseList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetLeaseList: []
    };
  }

  // api failed  response alert to user
  handleApiFailed = message => {
    this.setState({
      //Default alert
      alertType: "Default",
      showAlert: true,
      alertColor: "danger",
      alertMessage: message
    });
    window.scrollTo(0, 0);
  };

  // close alert message
  closeDefaultAlert = () => {
    this.setState({
      alertType: "",
      showAlert: false,
      alertColor: "",
      alertMessage: ""
    });
  };

  getAssetLeases = () => {
    let url = ASSET_LEASES_API;
    HttpUtil.get(
      url,
      {},
      data => this.setState({ assetLeaseList: data }),
      (data, status) => this.handleApiFailed(data.message),
      error => this.handleApiFailed(error.toString())
    );
  };

  componentDidMount() {
    this.getAssetLeases();
  }

  render() {
    const { assetLeaseList } = this.state;
    const alertProps = {
      show: this.state.showAlert,
      type: this.state.alertType,
      alertColor: this.state.alertColor,
      message: this.state.alertMessage,
      close: this.closeDefaultAlert
    };
    return (
      <Fragment>
        <div className="row mb-3">
          <div className="col-md-12">
            {/* show alert message  */}
            <AlertComponent {...alertProps} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card flex-fill">
              <div className="card-header bg-card-header text-white">
                <span className="card-title mb-0">
                  <i
                    className="fas fa-align-justify"
                    style={{ fontSize: "1.1em", cursor: "pointer" }}
                  />
                  &nbsp;&nbsp; Assets &nbsp;&nbsp;
                </span>
              </div>

              <div className="card-body">
                <div className="table-responsive-sm table-responsive-md table-responsive-lg">
                  <ToolkitProvider
                    keyField="_id"
                    data={assetLeaseList}
                    columns={ASSET_LEASE_COLUMNS}
                    bootstrap4={true}
                    search
                  >
                    {props => (
                      <Fragment>
                        {/* <div className="mb-2">
                          <SearchBar {...props.searchProps} />
                        </div> */}
                        <BootstrapTable
                          bootstrap4
                          keyField={"_id"}
                          data={assetLeaseList}
                          columns={ASSET_LEASE_COLUMNS}
                          condensed
                          striped
                          headerClasses="bg-card-header text-white"
                          // for pagination
                          pagination={paginationFactory({
                            page: 1,
                            sizePerPage: 10,
                            hideSizePerPage: true,
                            hidePageListOnlyOnePage: true
                          })}
                          //for search
                          {...props.baseProps}
                          //for custom css
                          className="react-bootstrap-table table .react-bootstrap-table td > .selection-input-4, .react-bootstrap-table th > .selection-input-4"
                          noDataIndication="No Data found"
                        />
                      </Fragment>
                    )}
                  </ToolkitProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AssetLeaseList;
